const gettingStarted = [
  {
    target: "#sooth-logo",
    content:
      "Welcome to Sooth.fyi! This is just a quick tour to walk you through some key features.",
  },
  {
    target: "#primary-search-box",
    content: "Type your search here using natural language or keywords.",
  },
  {
    target: "#pulse-nav-icon",
    content: "Click this icon to see the latest headlines.",
    placement: "left",
  },
  {
    target: "#collections-nav-icon",
    content: "Click here to access all your saved Research Collections.",
    placement: "left",
  },
  {
    target: "#tools-nav-icon",
    content: "Click here to access the Misinformation Toolkit.",
    placement: "left",
  },
  {
    target: "#profile-nav-icon",
    content: "This is your profile page. Check it out when you have time.",
    placement: "left",
  },
  {
    target: "#help-info-area",
    content:
      "In the footer you can find our Feedback button, Lesson Plans, Help Videos, and more.",
    data: {
      setup: async ({ index, action }) => {
        window.dispatchEvent(new CustomEvent("tour:app:searchClose"));
        window.dispatchEvent(new CustomEvent(action, { detail: index }));
      },
    },
  },
  {
    target: "#primary-search-box-text-field",
    content: "Let us show you an example search",
    data: {
      setup: async ({ index, action }) => {
        window.dispatchEvent(
          new CustomEvent("tour:app:searchOpen", {
            detail: {
              index,
              action,
            },
          })
        );
        window.dispatchEvent(
          new CustomEvent("tour:app:searchTerm", {
            detail: "What is Blockchain",
          })
        );
      },
    },
  },
  {
    target: "#primary-search-box-filters",
    content:
      "Whenever you type your search, this box will open, displaying the various search filters. Let’s leave all the default settings for now.",
  },
  {
    target: "#primary-search-box-search-button",
    content:
      "When you’re ready to search, click Search or press Enter on your keyboard.",
  },
  {
    target: "#tour-first-cat-section .tour-cat-section-card",
    placement: "right",
    content:
      "Your search results are organized into 7 categories. The order of these categories is dynamic and may change for each search. Make sure you scroll all the way down!",
    data: {
      setup: async ({ index, action, debug }) => {
        if (debug) {
          console.log("SEARCHSTEP:SETUP", index, action);
        }
        window.dispatchEvent(
          new CustomEvent("tour:app:search", {
            detail: {
              index,
              action,
              term: "What is Blockchain",
            },
          })
        );
      },
    },
  },
  {
    target: "#tour-first-cat-section .tour-cat-section-slider",
    content:
      "These are your results for this category. To see more, scroll to the right.",
  },
  {
    target: "#tour-first-cat-section .tour-cat-section-card-see-all",
    placement: "right",
    content: "Click here to see all the results for this category.",
    data: {
      scrollTo: false,
    },
  },
  {
    target: "#sooth-logo",
    content:
      "Clicking the Sooth icon will always bring you back to the Initial Search Page. That’s it for now!",
  },
];

export default gettingStarted;
